import { HotelCategory as component } from './component'
import { setCategory } from './reducer'
import { connect } from 'react-redux'

const mapDispatchToProps = (dispatch: (id: any) => void) => {
  return {
    topWaypointLeaveHandler: (id: string) => dispatch(setCategory(id)),
    bottomWaypointLeaveHandler: (id: string) => dispatch(setCategory(id))
  }
}

const container = connect(
  undefined,
  mapDispatchToProps
)(component)

export { container as HotelCategory }
